import { EventEmitter } from "events";
import dispatcher from "../dispatcher";
import { expenditureCatagoryConstant } from "../constants/constants";
class ExpenditureCatagoryStore extends EventEmitter {
    constructor() {
        super();
        this.exCats = [];
    }
    getAll() {
        return this.exCats;
    }

    handleAction(action) {
        switch (action.type) {
            case expenditureCatagoryConstant.EXPENDITURECATAGORY_CREATED: {
                //console.log(this);
                const { exCat } = action;
                this.exCats.push(exCat);
                this.emit(expenditureCatagoryConstant.EXPENDITURECATAGORY_CREATED, `Expenditure Catagory ${exCat.exCatName} created successfully.`);
                this.emit(expenditureCatagoryConstant.EXPENDITURECATAGORY_STORE_CHANGE);
                break;
            }
            case expenditureCatagoryConstant.EXPENDITURECATAGORY_CREATION_FAILED: {
                this.emit(expenditureCatagoryConstant.EXPENDITURECATAGORY_CREATION_FAILED, action.msg);
                break;
            }
            case expenditureCatagoryConstant.FETCHED_ALL_EXPENDITURECATAGORY: {
                //console.log("inside exCat store fetch all >>>>>>>>>>>>");
                this.exCats = action.data;
                this.emit(expenditureCatagoryConstant.EXPENDITURECATAGORY_STORE_CHANGE);
                break;
            }
            case expenditureCatagoryConstant.EXPENDITURECATAGORY_FETCH_FAILED: {
                this.emit(expenditureCatagoryConstant.EXPENDITURECATAGORY_FETCH_FAILED, action.msg);
                break;
            }
            default:
                break;
        }
    }
}

const expenditureCatagoryStore = new ExpenditureCatagoryStore();
dispatcher.register(expenditureCatagoryStore.handleAction.bind(expenditureCatagoryStore));
export default expenditureCatagoryStore;


// WEBPACK FOOTER //
// ./src/jsx/store/expenditure-catagory-store.jsx